<app-career-header-banner></app-career-header-banner>
<div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center">
  <span class="font-bold text-3xl website-heading">Diverse culture where curious minds collaborate</span>
</div>

<div class="w-full flex flex-col items-center justify-center gap-8 mt-10">

  <div class="flex items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <div>
      <div class="flex flex-col items-start justify-start gap-4 mt-4">
        <h3 class="text-xl font-bold ">iOS Developer</h3>
        <div class="flex gap-3 items-center">
          <img src="../../../../assets/images/careers/experience.png" alt="" class="size-5">
          <p class="text-black text-sm">5-6 years</p>
        </div>
        <div class="flex gap-3 items-center">
          <img src="../../../../assets/images/careers/job-location.png" alt="" class="size-5">
          <p class="text-black text-sm">Pune, Maharashtra</p>
        </div>
        <div class="flex gap-3 items-center">
          <img src="../../../../assets/images/careers/employment-type.png" alt="" class="size-5">
          <p class="text-black text-sm">Full Time</p>
        </div>
      </div>

    </div>
  </div>

  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">Roles and Responsibilities</span>
    <ul class="list-disc list-inside text-lg">
      <li class="mb-2 text-sm" *ngFor="let roles of roles">
        {{roles}}
      </li>
    </ul>
  </div>

  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">Qualification:</span>
    <ul class="list-disc list-inside text-lg">
      <li class="mb-2 text-sm" *ngFor="let skill of skills">
        {{skill}}
      </li>
    </ul>
  </div>

  <app-career-form-submission class="px-5 w-5/6 md:w-3/4" [jobDescription]="selectedJob"></app-career-form-submission>
</div>